<!-- TOPBAR (header + impersonation banner) — height is measured so the sidebar can size itself to fill exactly what's left of the viewport -->
<div class="topbar" #topbarEl>

<!-- HEADER -->
<header *ngIf="showHeader">
  <nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom shadow-sm">
    <div class="container-fluid">
      <button #toggleBtn
              type="button"
              class="btn p-0 me-2 d-inline-flex align-items-center justify-content-center header-icon"
              (click)="toggleSidebar()"
              aria-label="Toggle menu">
        <span class="fs-3 lh-1 text-primary">☰</span>
      </button>

      <a [routerLink]="['/home']" class="navbar-brand d-flex align-items-center me-3">
        <img src="assets/img/icon.png" alt="Well Chron" class="brand-logo" />
      </a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#wcMainNav"
              aria-controls="wcMainNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="wcMainNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li *ngIf="loginService.userOptional && loginService.userOptional.dashboards.length > 0" class="nav-item">
            <a [routerLink]="['/dashboards']" class="nav-link" routerLinkActive="active">Dashboards</a>
          </li>
          <li *ngIf="loginService.userOptional?.enableFracX || loginService.userOptional?.isGlobalAdmin" class="nav-item">
            <a [routerLink]="['/schedules']" class="nav-link" routerLinkActive="active">FracX</a>
          </li>
          <li *ngIf="loginService.userOptional?.enableAquatrade || loginService.userOptional?.enableAquashare" class="nav-item">
            <a [routerLink]="['/watersharing']" class="nav-link text-dark" routerLinkActive="active">AquaTrade</a>
          </li>
        </ul>

        <div class="d-flex align-items-center gap-3 gap-lg-4 ms-2 ms-lg-4">
          <!-- Notification bell -->
          <!--<app-notification-bell *ngIf="loginService.userOptional"></app-notification-bell>-->

          <!-- Admin dropdown -->
          <div *ngIf="loginService.userOptional?.isCompanyAdmin
                      || loginService.userOptional?.isGlobalAdmin
                      || loginService.userOptional?.isDeveloper"
               class="dropdown px-1 px-lg-2">
            <button type="button" class="btn btn-link nav-link dropdown-toggle p-0" id="adminMenu"
                    data-bs-toggle="dropdown" aria-expanded="false">
              Admin
            </button>
            <ul class="dropdown-menu dropdown-menu-end admin-menu" aria-labelledby="adminMenu">
              <li *ngIf="loginService.userOptional?.isCompanyAdmin">
                <a [routerLink]="['/user-management']" class="dropdown-item">Manage Users</a>
              </li>
              <li *ngIf="loginService.userOptional?.isDeveloper">
                <a [routerLink]="['/version-management']" class="dropdown-item">Developers</a>
              </li>
              <li *ngIf="loginService.userOptional?.isDeveloper">
                <a [routerLink]="['/models']" class="dropdown-item">Models</a>
              </li>
              <li *ngIf="loginService.userOptional?.isDeveloper">
                <a [routerLink]="['/task-event-history']" class="dropdown-item">Task Event History</a>
              </li>
              <li *ngIf="loginService.userOptional?.isGlobalAdmin">
                <a [routerLink]="['/client']" class="dropdown-item">Clients</a>
              </li>
              <li *ngIf="loginService.userOptional?.isGlobalAdmin">
                <a [routerLink]="['/prod-data']" class="dropdown-item">Production Data</a>
              </li>
              <li *ngIf="loginService.userOptional?.isGlobalAdmin">
                <a [routerLink]="['/dashboard-access']" class="dropdown-item">Dashboard Access</a>
              </li>
              <li *ngIf="loginService.userOptional?.isGlobalAdmin">
                <a [routerLink]="['/group-record-access-sync']" class="dropdown-item">Group Record Access Sync</a>
              </li>
            </ul>
          </div>

          <!-- Account dropdown -->
          <div class="dropdown me-2 me-lg-3">
            <button type="button"
                    class="btn btn-link nav-link dropdown-toggle d-flex align-items-center p-0"
                    id="accountMenu"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
              <img [src]="loginService.userOptional?.iconText" alt="logo" height="36px" width="auto" class="me-2 company-logo" />

              <span class="small fw-medium d-flex flex-column align-items-start text-start lh-sm">
                <ng-container *ngIf="!loginService.userOptional?.isImpersonating; else impLabel">
                  <span *ngIf="displayName as dn">{{ dn }}</span>
                  <span class="text-muted">{{ loginService.userOptional?.userName || 'Account' }}</span>
                </ng-container>
              </span>

              <ng-template #impLabel>
                <span class="fw-semibold" style="color:#b58105">
                  Impersonating:
                  {{ loginService.userOptional?.userName }}
                </span>
              </ng-template>
            </button>
            <ul class="dropdown-menu" aria-labelledby="accountMenu">
              <li class="dropdown-header">
                <div class="fw-semibold">{{ displayName }}</div>
                <div class="small text-muted">{{ loginService.userOptional?.userName }}</div>
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a class="dropdown-item" [routerLink]="['/user-settings']">
                  <i class="bi bi-gear me-2"></i> Settings
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/user-manuals']">
                  <i class="bi bi-book me-2"></i> User Manuals
                </a>
              </li>
              <li>
                <a class="dropdown-item"
                   href="#"
                   (click)="$event.preventDefault(); changePassword()">
                  <i class="bi bi-key me-2"></i> Change Password
                </a>
              </li>

              <li *ngIf="loginService.userOptional?.isImpersonating">
                <a class="dropdown-item"
                   href="#"
                   (click)="$event.preventDefault(); exitImpersonation()">
                  <i class="bi bi-person-check me-2"></i> Exit Impersonation
                </a>
              </li>

              <li><hr class="dropdown-divider" /></li>
              <li><a class="dropdown-item text-danger" (click)="logout()"><i class="bi bi-box-arrow-right me-2"></i> Sign out</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<!-- Impersonation banner -->
<div class="impersonation-banner" *ngIf="loginService.userOptional?.isImpersonating && showHeader">
  <i class="bi bi-exclamation-triangle-fill me-2"></i>
  Impersonating: <strong>{{ loginService.userOptional?.userName }}</strong>
  <a href="#" class="ms-3 text-white fw-semibold"
     (click)="$event.preventDefault(); exitImpersonation()">Exit Impersonation</a>
</div>

</div>
<!-- /TOPBAR -->

<app-loading-overlay></app-loading-overlay>

<!-- Mobile backdrop: closes sidebar when tapping outside on small screens -->
<div class="sidebar-backdrop" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>

<!-- PAGE BODY: sidebar + main content side by side -->
<div class="page-body">

  <!-- SIDEBAR -->
  <aside #sidebarEl class="sidebar" [class.open]="sidebarOpen" *ngIf="showHeader">
    <div class="sidebar-header d-flex align-items-center justify-content-between px-3 border-bottom">
      <h5 class="mb-0">Menu</h5>
      <button type="button" class="btn-close" (click)="closeSidebar()" aria-label="Close"></button>
    </div>

    <div class="sidebar-body p-0">
      <nav class="list-group list-group-flush">
        <a routerLink="/dashboards" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-speedometer2 me-3"></i> Dashboards
        </a>
        <a *ngIf="loginService.userOptional?.enableFracX" routerLink="/schedules" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-calendar3 me-3"></i> FracX
        </a>
        <a *ngIf="loginService.userOptional?.enableAquatrade || loginService.userOptional?.enableAquashare"
           routerLink="/watersharing" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-droplet-half me-3"></i> AquaTrade
        </a>
        <a *ngIf="loginService.userOptional?.isGlobalAdmin"
           routerLink="/prod-data" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-bar-chart-line me-3"></i> Production Data
        </a>

        <div *ngIf="loginService.userOptional?.isCompanyAdmin || loginService.userOptional?.isGlobalAdmin || loginService.userOptional?.isDeveloper"
             class="sidebar-section-label">Admin</div>
        <a *ngIf="loginService.userOptional?.isCompanyAdmin" routerLink="/user-management" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-people me-3"></i> Manage Users
        </a>
        <a *ngIf="loginService.userOptional?.isDeveloper" routerLink="/version-management" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-code-slash me-3"></i> Developers
        </a>
        <a *ngIf="loginService.userOptional?.isDeveloper" routerLink="/models" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-diagram-3 me-3"></i> Models
        </a>
        <a *ngIf="loginService.userOptional?.isDeveloper" routerLink="/task-event-history" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-list-ul me-3"></i> Task Event History
        </a>
        <a *ngIf="loginService.userOptional?.isGlobalAdmin" routerLink="/client" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-building me-3"></i> Clients
        </a>
        <a *ngIf="loginService.userOptional?.isGlobalAdmin" routerLink="/prod-data" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-bar-chart-line me-3"></i> Production Data
        </a>
        <a *ngIf="loginService.userOptional?.isGlobalAdmin" routerLink="/vendor" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-truck me-3"></i> Vendors
        </a>
        <a *ngIf="loginService.userOptional?.isGlobalAdmin" routerLink="/dashboard-access" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-shield-lock me-3"></i> Dashboard Access
        </a>
        <a *ngIf="loginService.userOptional?.isCompanyAdmin
                  || loginService.userOptional?.isGlobalAdmin
                  || loginService.userOptional?.isDeveloper"
           routerLink="/attachment-hierarchies" routerLinkActive="active"
           (click)="closeSidebar()"
           class="list-group-item list-group-item-action d-flex align-items-center">
          <i class="bi bi-folder2-open me-3"></i> Attachment Folders
        </a>

        <div *ngIf="loginService.userOptional?.isGlobalAdmin" class="px-3 py-3 border-top">
          <label class="form-label small mb-1">Switch To Client</label>
          <ejs-combobox id="comboClientSelect"
                        style="width: 100%"
                        [placeholder]="'View As Client...'"
                        [fields]="{ text: 'displayName', value: 'id' }"
                        [allowFiltering]="true"
                        [filterType]="'Contains'"
                        [allowCustom]="false"
                        (select)="onSelectClient($event)"
                        [value]="loginService.userOptional?.selectedClientId"
                        [dataSource]="sortedClients">
          </ejs-combobox>
        </div>

        <div class="sidebar-section-label">Account</div>
        <a class="list-group-item list-group-item-action d-flex align-items-center"
           [routerLink]="['/user-settings']" (click)="closeSidebar()">
          <i class="bi bi-gear me-3"></i> Settings
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center"
           (click)="changePassword(); closeSidebar()">
          <i class="bi bi-key me-3"></i> Change Password
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center"
           [routerLink]="['/user-manuals']" routerLinkActive="active" (click)="closeSidebar()">
          <i class="bi bi-book me-3"></i> User Manuals
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center"
           [routerLink]="['/contact-us']" (click)="closeSidebar()">
          <i class="bi bi-envelope me-3"></i> Contact Us
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center text-danger"
           (click)="logout()">
          <i class="bi bi-box-arrow-right me-3"></i> Sign out
        </a>
      </nav>
    </div>
  </aside>

  <!-- MAIN CONTENT -->
  <div class="main-content">
    <div class="container-fluid pt-2" *ngIf="showHeader">
      <router-outlet></router-outlet>
    </div>

    <div style="width:100%;max-width:100%;min-width:100%" *ngIf="!showHeader">
      <router-outlet></router-outlet>
    </div>

    <footer class="border-top footer text-muted" *ngIf="showHeader">
      <div class="container">&copy; 2025 - Well Chron</div>
    </footer>
  </div>

</div>
